import { render, staticRenderFns } from "./title.vue?vue&type=template&id=7c13440c&scoped=true&"
var script = {}
import style0 from "./title.vue?vue&type=style&index=0&id=7c13440c&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c13440c",
  null
  
)

export default component.exports